import styled, { css } from 'styled-components';

import { flexBetween, flexCenterAligned } from '@/styles/common';

const switcherThumbStyles = css`
  position: absolute;
  top: 4px;
  left: 5px;
  width: 50px;
  height: 34px;
  border-radius: 17.5px;
  z-index: 1;
  transition:
    transform 0.3s ease,
    background-color 0.3s ease;
`;

const thumbOffset = '52px';

export const SwitcherWrapper = styled.div<{ $isDarkMode: boolean }>`
  position: relative;
  height: 44px;
  width: 112px;
  padding: 11px 19px;
  background-color: transparent;
  border-radius: 28px;
  border: 1px solid var(--border-main);
  ${flexBetween};
  align-self: flex-end;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover::after {
    background-color: var(--bg-secondary);
  }

  &::after {
    content: '';
    ${switcherThumbStyles};
    top: 4px;
    background-color: transparent;
    transform: translateX(
      ${({ $isDarkMode }) => ($isDarkMode ? '0' : thumbOffset)}
    );
  }
`;

export const SwitcherCircle = styled.div<{ $isDarkMode: boolean }>`
  ${flexCenterAligned};
  ${switcherThumbStyles};
  background-color: ${({ $isDarkMode }) =>
    $isDarkMode ? 'var(--textAndLabels-main)' : 'var(--bg-tertiary)'};
  transform: translateX(
    ${({ $isDarkMode }) => ($isDarkMode ? thumbOffset : '0')}
  );
`;

export const IconsWrapper = styled.div<{ $isDarkMode: boolean }>`
  width: 100%;
  ${flexBetween};
  z-index: 2;

  svg:first-child {
    color: var(--textAndLabels-main);
  }

  svg:nth-child(2) {
    color: ${({ $isDarkMode }) =>
      $isDarkMode ? 'var(--bg-main)' : 'var(--textAndLabels-main)'};
  }
`;
